import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { UserTimelinesModal } from '@wilson/interfaces';
import { QualificationName, ShiftValidationDetails } from '@wilson/interfaces';
import { UserDetailsModule } from '@wilson/shared-components';
import { ShiftValidationsCoreModule } from '@wilson/shift-validations/core';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipBaseDirective, NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-user-timeline-info-qualifications',
  templateUrl: './user-timeline-info-qualifications.component.html',
  styleUrls: ['./user-timeline-info-qualifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzTooltipModule,
    NzSkeletonModule,
    ShiftValidationsCoreModule,
    UserDetailsModule,
  ],
})
export class UserTimelineInfoQualificationsComponent {
  @ViewChild('tooltip') tooltip!: NzTooltipBaseDirective;

  @Input() qualificationNames!: QualificationName[] | null;
  @Input() qualificationFulfilled: boolean | undefined | null = false;
  @Input() workingTimeValidations!: ShiftValidationDetails[] | null | undefined;
  @Input() professionValidations!: ShiftValidationDetails[] | null | undefined;
  @Input() shiftLogicValidations!: ShiftValidationDetails[] | null | undefined;
  @Input() user!: UserTimelinesModal | null | undefined;
  @Input() hasFinishedLoadingScores!: boolean | null;

  onTooltipExpanded() {
    this.tooltip.updatePosition();
  }
}
